import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import * as Actions from './actions'
import { callApi } from '../../../../utils/callApi'
import { API_ROUTES } from '../../../../utils/apiRoutes'
import { ActionTypes, IGetViewedItemsActivityChild, TViewedItemsActivity } from './types'

function* getViewedItemsActivityWorker(action: ReturnType<typeof Actions.GetViewedItemsActivity.request>) {
  const { callBack, idTender, offset, limit, search, sortBy, sort } =
    action.payload as Actions.TypeGetViewedItemsActivityR
  let success = true
  let data = null

  let query = `?Offset=${offset || 0}&Limit=${limit || 20}`
  query += search ? `&Search=${search}` : ''
  query += sortBy ? `&SortBy=${sortBy}` : ''
  query += sort ? `&Sort=${sort}` : ''
  query += `&Statistic=true`

  try {
    data = (yield call(callApi, {
      method: 'get',
      path: `${API_ROUTES.adminTenders}/${idTender}/items${query}`,
    })) as TViewedItemsActivity[]
    if (offset !== 0) {
      yield put(Actions.GetViewedItemsActivity.success(data))
    } else {
      yield put(Actions.GetViewedItemsActivityWith0Offset.success(data))
    }
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetViewedItemsActivity.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}

function* getViewedItemsActivityChildWorker(action: ReturnType<typeof Actions.GetViewedItemsActivityChild.request>) {
  const { callBack, idTender, idItem } = action.payload as Actions.TypeGetViewedItemsActivityChildR
  let success = true
  let data = null

  let query = `?Offset=${0}&Limit=${100}`
  query += `&ViewItemId=${idItem}`

  try {
    data = (yield call(callApi, {
      method: 'get',
      path: `${API_ROUTES.adminGetUsers}${query}`,
    })) as IGetViewedItemsActivityChild

    const { users } = data

    yield put(Actions.GetViewedItemsActivityChild.success({ data: users, idItem: +`${idTender}${idItem}` }))
  } catch (e) {
    success = false
    // @ts-ignore
    data = e?.data || e
    yield put(Actions.GetViewedItemsActivityChild.error(`${data?.message || data}`))
  } finally {
    if (callBack) callBack(success, data)
  }
}

function* watchRequest() {
  yield takeEvery(ActionTypes.GET_VIEWED_ITEM_ACTIVITY_R, getViewedItemsActivityWorker)
  yield takeEvery(ActionTypes.GET_VIEWED_ITEM_ACTIVITY_CHILD_R, getViewedItemsActivityChildWorker)
}

export default function* viewedItemsActivitySaga() {
  yield all([fork(watchRequest)])
}
